/* eslint-disable no-restricted-syntax */
import pickBy from 'lodash-es/pickBy';
import upperFirst from 'lodash-es/upperFirst';
import { v4 as uuidv4 } from 'uuid';

import { EVENT_TYPES } from 'components/Globals/Analytics/constants';

import { TRACKING_SESSION_KEY } from 'constants/cookieConstants';

import { setCookie, getCookie } from 'utils/cookie';

import { ENTITY_TYPES } from 'operabase-router/constants';

const getHumanReadabbeMetaInfo = meta => {
  const section = meta.section ? `${upperFirst(meta.section)}` : '';
  const component = meta.component ? ` / ${upperFirst(meta.component)}` : '';
  const subComponent = meta.subComponent ? ` / ${upperFirst(meta.subComponent)}` : '';
  const entityType = meta.entityType ? `${upperFirst(meta.entityType)} ` : '';
  return {
    section,
    component,
    subComponent,
    entityType,
  };
};

export const getHumanReadableEventName = (eventType, meta) => {
  if (eventType === EVENT_TYPES.PAGE_VIEW) {
    // Viewed Landing Page: Home
    return `Viewed ${upperFirst(meta.pageCategory)} Page: ${upperFirst(meta.pageType)}`;
  }

  const { section, component, subComponent, entityType } = getHumanReadabbeMetaInfo(meta);

  if (eventType === EVENT_TYPES.SEARCH) {
    return `${entityType}Searched (${section}${component}${subComponent})`;
  }

  if (eventType === EVENT_TYPES.IMPRESSION || eventType === EVENT_TYPES.CLICK) {
    // Artist Impression (ArtistSection / ArtistCard)
    // Artist Clicked (ArtistSection / ArtistCard)
    return eventType === EVENT_TYPES.IMPRESSION
      ? `${entityType}Impression (${section}${component}${subComponent})`
      : `${entityType}Clicked (${section}${component}${subComponent})`;
  }

  if (eventType === EVENT_TYPES.ACTION_CALL_BACK) {
    // Action Callback (ReturningUser / Modal / viewReturningUserModal / success)
    return `Action Callback (${section}${component}${subComponent}${meta?.step ? ` / ${upperFirst(meta.step)}` : ''}${
      meta?.actionStatus ? ` / ${upperFirst(meta.actionStatus)}` : ''
    })`;
  }

  return '';
};

export const removeEmptyValues = data => pickBy(data, value => value !== null && value !== undefined && value !== '');

const inThirtyMinutes = () => new Date(new Date().getTime() + 30 * 60 * 1000);

export const generateSessionId = () => {
  let sessionId = getCookie(TRACKING_SESSION_KEY);

  if (!sessionId) {
    sessionId = uuidv4();
    setCookie(TRACKING_SESSION_KEY, sessionId, inThirtyMinutes());
  }

  return sessionId;
};

export const isInternalUser = email => {
  if (!email) return false;
  // Need to check with ronak or vinit for user action control
  return ['@transfunnel', '@operabase', '@truelinked', '@artsconsolidated'].some(str => email.includes(str));
};

export const profileAccessForAnalytics = profileAccess =>
  profileAccess?.map(item => {
    let type = '';
    let relatedId = null;

    if (item?.organization) {
      type = ENTITY_TYPES.ORGANIZATION;
      relatedId = item?.organization?.id;
    } else if (item?.profile) {
      type = ENTITY_TYPES.PROFILE;
      relatedId = item?.profile?.id;
    }

    let organizationTypeSlug = item?.organization?.organizationType?.slug;

    return organizationTypeSlug?{
      id: relatedId,
      type,
      subType: organizationTypeSlug,
    }:{
      id: relatedId,
      type,
    };
  });
